import { render, staticRenderFns } from "./FormItemTag.vue?vue&type=template&id=015b3350"
import script from "./FormItemTag.vue?vue&type=script&lang=js"
export * from "./FormItemTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports